export const menu = [
    {
        text: "2022年度風格家庭",
        to: 'Section1'
    },
    {
        text: "名人風格家庭最愛封面票選",
        to: 'Section2'
    },
    {
        text: "社群風格家庭票選",
        to: 'Section3'
    },
    {
        text: "年度風格單品",
        to: 'Section4'
    },
    {
        text: "12星座媽咪風格育兒術",
        to: 'Section5'
    },
    {
        text: "潛力風格媽咪徵文",
        to: 'Section6'
    },
]

export const cover =[
        {
            id: 1,
            picUrl: './img/cover/01.jpg',
            name: '瑪G',
            title: '2022.08月封面'
        },
        {
            id: 2,
            picUrl: './img/cover/02.jpg',
            name: '蔡阿嘎＆二伯',
            title: '2022.07月封面'
        },
        {
            id: 3,
            picUrl: './img/cover/03.jpg',
            name: '許孟哲&趙孟姿',
            title: '2022.06月封面'
        },{
            id: 4,
            picUrl: './img/cover/04.jpg',
            name: '小蠻&邵翔',
            title: '2022.05月封面'
        },{
            id: 5,
            picUrl: './img/cover/05.jpg',
            name: 'rice & shine',
            title: '2022.04月封面'
        },{
            id: 6,
            picUrl: './img/cover/06.jpg',
            name: '簡廷芮',
            title: '2022.03月封面'
        },{
            id: 7,
            picUrl: './img/cover/07.jpg',
            name: '夏如芝',
            title: '2022.02月封面'
        },{
            id: 8,
            picUrl: './img/cover/08.jpg',
            name: 'Akemi',
            title: '2022.01月封面'
        },{
            id: 9,
            picUrl: './img/cover/09.jpg',
            name: '彥婷&巨人',
            title: '2021.12月封面'
        },{
            id: 10,
            picUrl: './img/cover/10.jpg',
            name: '白家綺&吳東諺',
            title: '2021.11月封面'
        },{
            id:11,
            picUrl: './img/cover/11.jpg',
            name: '林叨囝仔',
            title: '2021.09月封面'
        },{
            id: 12,
            picUrl: './img/cover/12.jpg',
            name: '吳念真&吳定謙',
            title: '2021.08月封面'
        },{
            id: 13,
            picUrl: './img/cover/13.jpg',
            name: '營養師高敏敏',
            title: '2021.08月封面'
        },{
            id: 14,
            picUrl: './img/cover/14.jpg',
            name: '國際服裝設計師Jenn Lee',
            title: '2021.08月封面'
        },{
            id: 15,
            picUrl: './img/cover/15.jpg',
            name: '健身部落客Michelle',
            title: '2021.08月封面'
        },{
            id: 16,
            picUrl: './img/cover/16.jpg',
            name: '王思佳',
            title: '2021.07月封面'
        },{
            id: 17,
            picUrl: './img/cover/17.jpg',
            name: '巴鈺',
            title: '2021.06月封面'
        },{
            id: 18,
            picUrl: './img/cover/18.jpg',
            name: '林可彤',
            title: '2021.04月封面'
        },{
            id: 19,
            picUrl: './img/cover/19.jpg',
            name: 'Janet謝怡芬',
            title: '2021.02月封面'
        },{
            id: 20,
            picUrl: './img/cover/20.jpg',
            name: '廖曉喬',
            title: '2021.01月封面'
        }
    ];

export const family = [
    {
        id: 1,
        picUrl: './img/family/001.png',
        name: '1+1=3。小Yo之家',
        title: '2022.08月封面'
    },
    {
        id: 2,
        picUrl: './img/family/002.png',
        name: 'Adrianne Lu 倩兒',
        title: '2022.07月封面'
    },
    {
        id: 3,
        picUrl: './img/family/003.png',
        name: 'Amigo H.',
        title: '2022.06月封面'
    }, {
        id: 4,
        picUrl: './img/family/004.png',
        name: 'Becca',
        title: '2022.05月封面'
    }, {
        id: 5,
        picUrl: './img/family/005.png',
        name: 'BerryMom',
        title: '2022.04月封面'
    }, {
        id: 6,
        picUrl: './img/family/006.png',
        name: 'Elsa菲常好攝',
        title: '2022.03月封面'
    }, {
        id: 7,
        picUrl: './img/family/007.png',
        name: 'Pupupepe 浿機',
        title: '2022.02月封面'
    }, {
        id: 8,
        picUrl: './img/family/008.png',
        name: 'Smile Life維媽育兒生活',
        title: '2022.01月封面'
    }, {
        id: 9,
        picUrl: './img/family/009.png',
        name: '勺勺吃喝玩樂',
        title: '2021.12月封面'
    }, {
        id: 10,
        picUrl: './img/family/010.png',
        name: '布布媽咪',
        title: '2021.11月封面'
    }, {
        id: 11,
        picUrl: './img/family/011.png',
        name: '艾唯的育兒生活',
        title: '2021.09月封面'
    }, {
        id: 12,
        picUrl: './img/family/012.png',
        name: '艾瑞絲',
        title: '2021.08月封面'
    }, {
        id: 13,
        picUrl: './img/family/013.png',
        name: '妞妞TV',
        title: '2021.08月封面'
    }, {
        id: 14,
        picUrl: './img/family/014.png',
        name: '阿波這一家',
        title: '2021.08月封面'
    }, {
        id: 15,
        picUrl: './img/family/015.png',
        name: '美美媽咪和美咪',
        title: '2021.08月封面'
    }, {
        id: 16,
        picUrl: './img/family/016.png',
        name: '桑妮Sunny',
        title: '2021.07月封面'
    }, {
        id: 17,
        picUrl: './img/family/017.png',
        name: '茜茜與人夫謙',
        title: '2021.06月封面'
    }, {
        id: 18,
        picUrl: './img/family/018.png',
        name: '高個夫妻。Janemy 珍米 House',
        title: '2021.04月封面'
    }, {
        id: 19,
        picUrl: './img/family/019.png',
        name: '偶疑的梅子與南瓜',
        title: '2021.02月封面'
    }, {
        id: 20,
        picUrl: './img/family/020.png',
        name: '晨晨喬喬玩樂日記',
        title: '2021.01月封面'
    }, {
        id: 21,
        picUrl: './img/family/021.png',
        name: '荳荳迪迪ㄞ、玩樂',
    },
    {
        id: 22,
        picUrl: './img/family/022.png',
        name: '結婚。幸福',
    },
    {
        id: 23,
        picUrl: './img/family/023.png',
        name: '菲菲媽咪的育兒生活',
    },
    {
        id: 24,
        picUrl: './img/family/024.png',
        name: '媽Mie這一周',
    },
    {
        id: 25,
        picUrl: './img/family/025.png',
        name: '愛甯Spencer',
    },
    {
        id: 26,
        picUrl: './img/family/026.png',
        name: '萱妮 Cherie Stylery',
    },
    {
        id: 27,
        picUrl: './img/family/027.png',
        name: '葛瑞絲的天堂',
    },
    {
        id: 28,
        picUrl: './img/family/028.png',
        name: '摳媽與摳比',
    },
    {
        id: 29,
        picUrl: './img/family/029.png',
        name: '劉宇彤Haruka',
    },
    {
        id: 30,
        picUrl: './img/family/030.png',
        name: '鄭欣妍La媽',
    },
    {
        id: 31,
        picUrl: './img/family/031.png',
        name: '靜怡&大顆呆の親子.旅遊.美食',
    },
    {
        id: 32,
        picUrl: './img/family/032.png',
        name: '寶寶吳迪 Babywoody',
    }
];

